import { get } from 'lodash';
import { Action } from '../types/types';
import { actionTypes } from './globals';

export const analyzeAction = (action: Action) => {
  const { type = '', payload } = action;
  const { withMerge } = payload ?? {};

  const actionInfo = actionTypes[type];
  const isClear = get(action, '@@redux-store-generator/CLEAR_ACTION', false);
  const isInner = type.includes('.') || type.includes('/');
  const isBootstrap = get(action, '@@redux-store-generator/BOOTSTRAP_ACTION', false);

  if (!actionInfo) {
    return null;
  }

  return {
    ...actionInfo,
    withMerge,
    isClear,
    isBootstrap,
    isInner,
  };
};
